import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'set_password' */ './SetPassword'),
);
